module.exports = __webpack_public_path__ + "img/loading_top.0e3cab68.jpg";